var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from "react";
import "@frameworks/shared-library/stylesheets/components/OrderBookSideBar/OrderBookSideBar";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { renderValue, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
/**
 * OrderBookSideBarSchemeDetails
 *
 * This component is to display the Scheme-order details
 *
 * @param {Object} details - Key-value pair to display details
 * @param {string} parentClassName - Any parent scss class to control stylings
 * @returns {}
 */
var OrderBookSideBarSchemeDetails = function (props) {
    var _a;
    var _b = __read(useState(false), 2), viewMore = _b[0], setViewMore = _b[1];
    return (React.createElement("div", { className: "primary-scheme-details-container ".concat((props === null || props === void 0 ? void 0 : props.parentClassName) ? props.parentClassName : "") },
        React.createElement("div", { className: "scheme-details" }, (_a = props.details)
            .slice.apply(_a, __spreadArray([], __read((viewMore ? [] : [0, 3])), false)).map(function (_a) {
            var label = _a.label, value = _a.value, valueType = _a.valueType;
            return (React.createElement("div", { className: "d-flex flex-column details-item", id: label, key: label },
                React.createElement("label", { className: "item-label DMSansNormal_12_400" }, label),
                renderValue(valueType, value)));
        })),
        React.createElement("div", { className: "d-flex flex-row justify-content-center align-items-center view-more-details" },
            React.createElement(EdButton, { btnTyp: "text-only", onClick: function () { return setViewMore(!viewMore); }, className: "DMSansNormal_12_400 txt-han-blue", value: React.createElement("span", { className: "d-flex align-items-center gap-1" },
                    React.createElement("span", { className: "text-decoration-underline" }, viewMore ? "View Less" : "View More"),
                    React.createElement("i", { className: viewMore ? "edel-icon-arrow-up-thin" : "edel-icon-arrow-down" })) }))));
};
export default OrderBookSideBarSchemeDetails;
